export default __webpack_public_path__ + "static/home_background-777e49a895a0f094f8819ed59b6dc764.jpg";